import { Input } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useCustomerForm } from '../../../../contexts/customerFormContext'
import { ShippingAddressInputFieldProps } from '../../types/shippingAddressInputFieldProps'

type ShippingAddressStreet2Props = ShippingAddressInputFieldProps

export const ShippingAddressStreet2 = ({ isDisabled }: ShippingAddressStreet2Props): ReactElement => {
  const { t } = useTranslation()
  const { customerForm } = useCustomerForm()
  const { FormItem } = customerForm

  return (
    <FormItem
      label={t('customer_modal.form.shipping_address.street_address_2.label')}
      name="shippingAddress.streetAddress2"
      render={({ field }) => <Input {...field} disabled={isDisabled} size="sm" />}
    />
  )
}
